import { render, staticRenderFns } from "./HeaderNotice.vue?vue&type=template&id=a195466a"
import script from "./HeaderNotice.vue?vue&type=script&lang=js"
export * from "./HeaderNotice.vue?vue&type=script&lang=js"
import style0 from "./HeaderNotice.vue?vue&type=style&index=0&id=a195466a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports